import { tv, type VariantProps } from "../../../util/tv";

export const contactFormVariant = tv({
  slots: {
    base: ["grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2"],
  },
});

export type ContactFormVariantProps = VariantProps<typeof contactFormVariant>;
